import { useMutation, useQueryClient } from '@tanstack/react-query';
import { KANBAN_QUERY_KEY } from '@/components/TramitesKanban/kanbanUtils';
import { costoService } from '@/services/costoService';
import { PRESUPUESTOS_PROFORMA_QUERY_KEY } from './usePresupuestosProforma';

interface DesasociarPresupuestoParams {
  tramiteId: string;
  eliminarItems: boolean;
}

/**
 * Corta el vínculo entre una escritura y el presupuesto importado. Se usa desde
 * la escritura y desde el listado y el detalle de presupuestos.
 */
export const useDesasociarPresupuesto = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ tramiteId, eliminarItems }: DesasociarPresupuestoParams) =>
      costoService.desasociarProforma(tramiteId, eliminarItems),
    onSuccess: (_data, { tramiteId }) => {
      queryClient.invalidateQueries({ queryKey: ['costos', tramiteId] });
      queryClient.invalidateQueries({ queryKey: PRESUPUESTOS_PROFORMA_QUERY_KEY });
      // El indicador de presupuesto de la escritura depende del vínculo.
      queryClient.invalidateQueries({ queryKey: KANBAN_QUERY_KEY });
    },
  });

  return {
    desasociar: mutation.mutateAsync,
    isDesasociando: mutation.isPending,
  };
};
